import researcherIcon from 'src/images/icons/art-researcher.svg';
import researcherDarkIcon from 'src/images/icons/art-researcher-dark.svg';
import { UpsellCard } from 'src/v2/commonComponents/UpsellCard';

interface SuperAgentUpsellProps {
  description: string;
}

export const SuperAgentUpsell = ({ description }: SuperAgentUpsellProps) => {
  return (
    <UpsellCard
      darkIcon={researcherDarkIcon}
      lightIcon={researcherIcon}
      description={description}
      dataGTM="SuperAgent-message"
      shouldShowUpgrade
      upgradeTitle="Upgrade"
    />
  );
};
